import { useEffect } from 'react'
import { getClientId } from './fingerprint'
import { toDeviceInfo, sendHeartbeat, localHeartbeat, type StatsSnapshot } from './analytics'

const HEARTBEAT_INTERVAL_MS = 15_000
const SESSION_TIMEOUT_MS = 30 * 60 * 1000 // بعد از ۳۰ دقیقه بی‌فعالیتی، بازدید جدید حساب می‌شود

/**
 * قلاب ردیابی بازدید — فقط در صفحهٔ اصلی نصب می‌شود.
 *
 * هر ۱۵ ثانیه یک نبض به سرور می‌فرستد؛ سرور بر اساس شناسهٔ دستگاه، «آنلاین
 * بودن» و شمارش بازدیدها را به‌روز می‌کند. هنگام بستن تب هم با sendBeacon یک
 * نبض نهایی ارسال می‌شود.
 */
export function useSiteTracking(): void {
  useEffect(() => {
    const clientId = getClientId()
    const device = toDeviceInfo()
    let stopped = false

    const sessionKey = `elona_last_pulse_${clientId}`
    const isNewSession = (): boolean => {
      try {
        const last = Number(sessionStorage.getItem(sessionKey) ?? 0)
        return !last || Date.now() - last > SESSION_TIMEOUT_MS
      } catch {
        return true
      }
    }
    const markPulse = (): void => {
      try {
        sessionStorage.setItem(sessionKey, String(Date.now()))
      } catch {
        // بی‌اهمیت
      }
    }

    const beat = (): void => {
      if (stopped) return
      const newSession = isNewSession()
      markPulse()
      sendHeartbeat({ clientId, device, newSession }).then((stats: StatsSnapshot | null) => {
        if (!stats) localHeartbeat(clientId, device, newSession)
      })
    }

    beat()
    const interval = window.setInterval(beat, HEARTBEAT_INTERVAL_MS)

    // نبض نهایی هنگام خروج
    const onUnload = (): void => {
      try {
        navigator.sendBeacon(
          '/api/heartbeat-beacon',
          new Blob([JSON.stringify({ clientId, device, newSession: false })], {
            type: 'application/json',
          }),
        )
      } catch {
        // sendBeacon در دسترس نیست
      }
    }
    window.addEventListener('pagehide', onUnload)

    return () => {
      stopped = true
      window.clearInterval(interval)
      window.removeEventListener('pagehide', onUnload)
    }
  }, [])
}
